
  import { defineComponent } from 'vue'
  import ResultDisplay from '@/components/ResultDisplay/ResultDisplay.vue'
  import ViewShell from '@/components/ViewShell/ViewShell.vue'

  export default defineComponent({
    components: { ViewShell, ResultDisplay },
    beforeRouteEnter(to, from, next) {
      // TODO: Implement guard
      next()
    },
  })
